import React from "react";
import { Button, Icon, Toast } from "antd-mobile";
import { post } from "../../utils/request";
import { href, encode } from "../../utils/util";
import PapersUploadGR from "../modules/papersUpload_GR";
import AttestationType from "../modules/attestationType";
import PapersUploadQY from "../modules/papersUpload_QY";
import AttestationStatus from "../modules/attestationStatus";
import AgreementText from "../modules/agreementText";
import DigitalText from "../modules/digitalText";

import api from "./api";
import Cookies from "js-cookie";
import wx from "wx";
import { SSQUrl } from "../../utils/config";

import "./index.less";

let submitType;
class ACEnterprosePapers extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            iconType: false,
            phoneNumber: "", //手机号
            identifyCode: "", //验证码
            caType: "MOBILE", //认证方式： MOBILE（手机号验证），PERSONAL（刷脸认证）,AUTH(授权书)
            cerificationNo: "", //身份证号码
            legalPersonName: "", //法人姓名
            customerName: "", //企业名称
            front: "", //身份证正面
            back: "", //身份证反面
            //   authBook: "", //授权书
            orgIdentity: "", //营业执照
            regCode: "", // 统一社会信用代码
            name: "", // 身份证姓名
            status: "", // 是否认证成功状态
            agreementTextStatus: false, //协议文案展示状态
            digitalTextStatus: false, //协议文案展示状态
            urlOps: {},
            personalIdentity3Key: "",
            plateformType: "EQB",
            isHideNoAuth: false,
        };
    }

    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    if (ops.plateformType) {
                        this.setState({
                            plateformType: ops.plateformType,
                        });
                    } else {
                        this.getPlateformType();
                    }
                }
            );
        }
    }

    // 查询默认认证平台类型
    getPlateformType = () => {
        const { urlOps } = this.state;
        let url = "";
        let auth = "";
        if (localStorage.getItem("app_stoken")) {
            auth = localStorage.getItem("app_stoken");
            url =
                "/gateway/manageBedrock/bdDictionarycs/selectBdDictionary?app_stoken=" +
                localStorage.getItem("app_stoken");
        } else if (localStorage.getItem("sessionKey")) {
            url =
                "/gateway/manageBedrock/bdDictionarycs/selectBdDictionary?sessionKey=" +
                localStorage.getItem("sessionKey");
            auth = localStorage.getItem("sessionKey");
        } else {
            url =
                "/gateway/manageBedrock/bdDictionarycs/selectBdDictionary?session_key=" +
                Cookies.get("session_key");
            auth = Cookies.get("session_key");
        }
        post({
            url,
            data: {
                dictionaryCode: "SIGN_PLATEFORM_TYPE",
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    this.setState({
                        plateformType: res.data.dictionaryValue,
                    });
                }
            },
            (res) => {
                console.log("查询查询默认认证平台类型失败", res);
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("查询查询默认认证平台类型失败", 1);
                }
            }
        );

        this.getQueryCustomerInfo(auth);
    };
    // 查询客户信息
    getQueryCustomerInfo = (auth) => {
        post({
            url: api.h5.queryCustomerInfo + "?app_stoken=" + auth,
            data: {},
        }).then(
            (res) => {
                if (res.result === "success") {
                    let isHideNoAuth =
                        res.data.tiertype === "4" &&
                        res.data.defaultTenant.tenantType == "HGC";
                    this.setState({
                        isHideNoAuth,
                    });
                }
            },
            (res) => {
                console.log("查询客户信息失败", res);
                if (res.code == "-1") {
                    Toast.info("登录失效", 1);
                } else {
                    Toast.info("查询客户信息失败", 1);
                }
            }
        );
    };
    submit = () => {
        let {
            iconType,
            caType,
            customerName,
            regCode,
            legalPersonName,
            cerificationNo,
            phoneNumber,
            name,
            identifyCode,
            front,
            back,
            orgIdentity,
            authBook,
            personalIdentity3Key,
            plateformType,
        } = this.state;
        let _this = this;
        // 防重复点击
        if (submitType) {
            return;
        }
        if (caType !== "PERSONAL") {
            var ops = {};
            if (caType === "MOBILE") {
                ops = {
                    caType: "MOBILE",
                    customerName: customerName,
                    identity: regCode,
                    legalPersonName: legalPersonName,
                    legalPersonIdentityNo: cerificationNo,
                    phoneNumber: phoneNumber,
                    identityImage: {
                        front: front,
                        back: back,
                        orgIdentity: orgIdentity,
                    },
                };

                if (plateformType === "SSQ") {
                    ops.identifyCode = identifyCode;
                }
            } else {
                ops = {
                    caType,
                    customerName: customerName,
                    identity: regCode,
                    legalPersonName: legalPersonName,
                    // legalPersonIdentityNo: cerificationNo,
                    phoneNumber: phoneNumber,
                    authPerson: name,
                    authIdentity: cerificationNo,
                    authMobileNumber: phoneNumber,
                    //   identifyCode: identifyCode,
                    identityImage: {
                        front: front,
                        back: back,
                        orgIdentity: orgIdentity,
                        // authBook: authBook,
                    },
                };

                if (plateformType === "SSQ") {
                    ops.identifyCode = identifyCode;
                    ops.identityImage.authBook = authBook;
                }
            }
            this.setState(
                {
                    status: "loading",
                },
                () => {
                    let url = "";
                    if (localStorage.getItem("app_stoken")) {
                        url =
                            api.h5.organizationPermission +
                            "?app_stoken=" +
                            localStorage.getItem("app_stoken");
                    } else if (localStorage.getItem("sessionKey")) {
                        url =
                            api.wechat.organizationPermission +
                            "?sessionKey=" +
                            localStorage.getItem("sessionKey");
                    } else {
                        url =
                            api.h5.organizationPermission +
                            "?session_key=" +
                            Cookies.get("session_key");
                    }

                    submitType = true;

                    post({
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                        },
                        data: { ...ops, personalIdentity3Key, plateformType },
                    }).then(
                        (res) => {
                            submitType = false;
                            console.log("企业认证", res);
                            if (res.result === "success") {
                                // this.setState({
                                //     status: 'success'
                                // });
                                if (plateformType === "EQB") {
                                    window.location.href = res.data.eqb.url;
                                } else {
                                    href("/ACFaceCaCompact");
                                }
                            } else {
                                this.setState({
                                    status: "error",
                                });
                                if (res.code == "-1") {
                                    href("/ACLoginCompact");
                                    Toast.info("登录失效", 1);
                                } else {
                                    Toast.info("企业认证失败", 1);
                                }
                            }
                        },
                        (res) => {
                            submitType = false;
                            console.log("企业认证失败", res);
                            this.setState({
                                status: "error",
                            });
                            if (res.code == "-1") {
                                href("/ACLoginCompact");
                                Toast.info("登录失效", 1);
                            } else {
                                Toast.info("企业认证失败", 1);
                            }
                        }
                    );
                }
            );
        } else {
            let url = "",
                mobileNumber,
                returnUrl;
            if (localStorage.getItem("app_stoken")) {
                url =
                    api.h5.getPersonalFaceCaUrl +
                    "?app_stoken=" +
                    localStorage.getItem("app_stoken");
                mobileNumber = this.state.urlOps.mobileNumber;
                returnUrl =
                    window.location.origin +
                    window.location.pathname +
                    "#/ACFaceCaCompact?url=" +
                    encode(
                        window.location.href +
                            "&app_stoken=" +
                            localStorage.getItem("app_stoken")
                    );
            } else if (localStorage.getItem("sessionKey")) {
                url =
                    api.wechat.getPersonalFaceCaUrl +
                    "?sessionKey=" +
                    localStorage.getItem("sessionKey");
                mobileNumber = this.state.urlOps.mobileNumber;
                returnUrl =
                    window.location.origin +
                    window.location.pathname +
                    "#/ACFaceCaCompact?url=" +
                    encode(
                        window.location.href +
                            "&sessionKey=" +
                            localStorage.getItem("sessionKey")
                    );
            } else {
                url =
                    api.h5.getPersonalFaceCaUrl +
                    "?session_key=" +
                    Cookies.get("session_key");
                mobileNumber = this.state.urlOps.mobileNumber;
                returnUrl =
                    window.location.origin +
                    window.location.pathname +
                    "#/ACFaceCaCompact?url=" +
                    encode(
                        window.location.href +
                            "&session_key=" +
                            Cookies.get("session_key")
                    );
            }
            if (!mobileNumber) {
                Toast.info("刷脸认证异常，请选择手机号认证", 1);
                return;
            }

            submitType = true;

            post({
                url: url,
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    from: localStorage.getItem("sessionKey") ? "MINI" : "H5",
                    userType: 2,
                    mobileNumber: mobileNumber,
                    name: customerName,
                    identity: regCode,
                    returnUrl: returnUrl,
                    callbackHost: SSQUrl,
                    legalPersonName: name,
                    legalPersonIdentityNo: cerificationNo,
                    idCardFront: front,
                    idCardBack: back,
                    plateformType,
                },
            }).then(
                (res) => {
                    submitType = false;
                    console.log("刷脸认证", res);
                    if (res.result === "success") {
                        if (localStorage.getItem("sessionKey")) {
                            wx.miniProgram.redirectTo({
                                url:
                                    "../face-webview/face-webview?url=" +
                                    encodeURIComponent(res.data),
                            });
                        } else {
                            window.location.href = res.data;
                        }
                    } else {
                        if (res.code == "-1") {
                            href("/ACLoginCompact");
                            Toast.info("登录失效", 1);
                        } else {
                            Toast.info("刷脸认证失败", 1);
                        }
                    }
                },
                (res) => {
                    submitType = false;
                    console.log("刷脸认证失败", res);
                    if (res.code == "-1") {
                        href("/ACLoginCompact");
                        Toast.info("登录失效", 1);
                    } else {
                        Toast.info("刷脸认证失败", 1);
                    }
                }
            );
        }
    };

    submitTypeStatus = () => {
        const {
            iconType,
            phoneNumber,
            identifyCode,
            caType,
            cerificationNo,
            legalPersonName,
            customerName,
            front,
            back,
            authBook,
            orgIdentity,
            regCode,
            name,
            //   status,
            //   agreementTextStatus,
            //   digitalTextStatus,
            plateformType,
        } = this.state;

        if (plateformType === "EQB") {
            return (
                (caType === "MOBILE" &&
                    phoneNumber &&
                    //   identifyCode &&
                    cerificationNo &&
                    legalPersonName &&
                    customerName &&
                    front &&
                    back &&
                    orgIdentity &&
                    regCode &&
                    name &&
                    iconType) ||
                (caType === "PERSONAL" &&
                    cerificationNo &&
                    legalPersonName &&
                    customerName &&
                    front &&
                    back &&
                    orgIdentity &&
                    regCode &&
                    name &&
                    iconType) ||
                (caType === "AUTH" &&
                    phoneNumber &&
                    //   identifyCode &&
                    cerificationNo &&
                    legalPersonName &&
                    customerName &&
                    front &&
                    back &&
                    orgIdentity &&
                    regCode &&
                    name &&
                    //   authBook &&
                    iconType)
            );
        } else {
            return (
                (caType === "MOBILE" &&
                    phoneNumber &&
                    identifyCode &&
                    cerificationNo &&
                    legalPersonName &&
                    customerName &&
                    front &&
                    back &&
                    orgIdentity &&
                    regCode &&
                    name &&
                    iconType) ||
                (caType === "PERSONAL" &&
                    cerificationNo &&
                    legalPersonName &&
                    customerName &&
                    front &&
                    back &&
                    orgIdentity &&
                    regCode &&
                    name &&
                    iconType) ||
                (caType === "AUTH" &&
                    phoneNumber &&
                    identifyCode &&
                    cerificationNo &&
                    legalPersonName &&
                    customerName &&
                    front &&
                    back &&
                    orgIdentity &&
                    regCode &&
                    name &&
                    authBook &&
                    iconType)
            );
        }
    };

    render() {
        let {
            iconType,
            phoneNumber,
            identifyCode,
            caType,
            cerificationNo,
            legalPersonName,
            customerName,
            //   front,
            //   back,
            //   authBook,
            //   orgIdentity,
            regCode,
            name,
            status,
            agreementTextStatus,
            digitalTextStatus,
            plateformType,
        } = this.state;
        return (
            <div className="ACEnterprosePapersBox">
                <div className="blockBox">
                    <h3>企业证件</h3>
                    <PapersUploadQY
                        customerName={customerName}
                        regCode={regCode}
                        legalPerson={legalPersonName}
                        onCancel={(
                            legalPersonName,
                            customerName,
                            orgIdentity,
                            regCode
                        ) => {
                            console.log(orgIdentity);
                            this.setState({
                                legalPersonName,
                                customerName,
                                orgIdentity,
                                regCode,
                            });
                        }}
                    />
                </div>
                <div className="blockBox">
                    <h3>
                        个人证件
                        <div className="agreeBox">
                            {!this.state.isHideNoAuth && (
                                <label
                                    onClick={() => {
                                        this.setState({
                                            caType:
                                                this.state.caType === "AUTH"
                                                    ? "MOBILE"
                                                    : "AUTH",
                                        });
                                    }}
                                >
                                    {this.state.caType === "AUTH" ? (
                                        <Icon type="check" />
                                    ) : (
                                        <Icon />
                                    )}
                                    <div>我没有法定代表人的身份证</div>
                                </label>
                            )}
                        </div>
                    </h3>
                    <PapersUploadGR
                        selectSign="法定代表人"
                        fangShi={this.state.caType}
                        name={name}
                        cerificationNo={cerificationNo}
                        onCancel={(cerificationNo, name, front, back) => {
                            this.setState({
                                cerificationNo,
                                name,
                                front,
                                back,
                            });
                        }}
                    />
                </div>
                <div className="blockBox">
                    <h3>
                        {this.state.caType === "AUTH"
                            ? "授权书认证"
                            : "请选择认证方式"}
                    </h3>
                    <AttestationType
                        selectSign="法定代表人"
                        fangShi={this.state.caType}
                        phoneNumber={phoneNumber}
                        identifyCode={identifyCode}
                        source={"QY"}
                        cerificationNo={cerificationNo}
                        customerName={name}
                        regCode={regCode}
                        plateformType={plateformType}
                        onCancel={(
                            phoneNumber,
                            identifyCode,
                            caType,
                            personalIdentity3Key,
                            authBook
                        ) => {
                            this.setState({
                                phoneNumber,
                                identifyCode,
                                caType,
                                personalIdentity3Key,
                                authBook,
                            });
                        }}
                    />
                </div>
                <div className="agreeBox">
                    <label
                        onClick={() => {
                            console.log(this.state.caType);
                            this.setState({
                                iconType: !iconType,
                            });
                        }}
                    >
                        {iconType ? <Icon type="check" /> : <Icon />}
                        <div>
                            我同意远程慧联对我提交的个人身份信息的保护办法
                            <a
                                onClick={() => {
                                    this.setState({
                                        agreementTextStatus: true,
                                    });
                                }}
                            >
                                《远程慧联如何保护您的信息》
                            </a>
                            <a
                                onClick={() => {
                                    this.setState({
                                        digitalTextStatus: true,
                                    });
                                }}
                            >
                                《数字证书使用协议》
                            </a>
                        </div>
                    </label>
                </div>
                <div className="queryBtnBox">
                    {this.submitTypeStatus() ? (
                        <Button
                            type="primary"
                            onClick={this.submit}
                        >
                            确认提交
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            disabled
                        >
                            确认提交
                        </Button>
                    )}
                    <div style={{ padding: "10px" }}>
                        个人身份信息将用于申请数字证书
                    </div>
                </div>
                <AttestationStatus
                    status={status}
                    caType={caType}
                    onRestart={() => {
                        this.submit();
                    }}
                    onQuit={(status) => {
                        this.setState({
                            status,
                        });
                    }}
                />
                {agreementTextStatus ? (
                    <AgreementText
                        agreementTextStatus={agreementTextStatus}
                        onQuit={(agreementTextStatus) => {
                            this.setState({
                                agreementTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
                {digitalTextStatus ? (
                    <DigitalText
                        digitalTextStatus={digitalTextStatus}
                        onQuit={(digitalTextStatus) => {
                            this.setState({
                                digitalTextStatus,
                            });
                        }}
                    />
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default ACEnterprosePapers;



// WEBPACK FOOTER //
// ./src/authCertificateCompact/ACEnterprosePapers/index.js